export default "__VITE_ASSET__kN3ZRkxW__"